import { Component, inject, model } from '@angular/core';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogActions, MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { Genre } from '@shared/interfacres/genre';
import { MatButton } from '@angular/material/button';


@Component({
  selector: 'app-edit-subgenre-dialog',
  templateUrl: 'edit-subgenre-dialog.html',
  styleUrl: './edit-subgenre-dialog.scss',
  imports: [
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatButton,
    MatDialogClose,
  ],
})
export class EditSubgenreDialog {
  readonly dialogRef = inject(MatDialogRef<EditSubgenreDialog>);
  readonly data = inject<Genre>(MAT_DIALOG_DATA);
  readonly subgenreName = model('');

  constructor() {
    if (this.data?.name)
    this.subgenreName.set(this.data.name);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
